import { TransactionApi } from '../../infrastructure/api';
import { TransactionApiData } from '../../shared/types';

export class LoadTransactionsUseCase {
    async execute(supplierId: number, token: string): Promise<TransactionApiData[]> {
        return await TransactionApi.fetchBySupplierId(supplierId, token);
    }
}

